// extracted by mini-css-extract-plugin
export default {"signForm":"style_signForm__nxmGv","wrapper":"style_wrapper__ALId5","form":"style_form__fd1or","image":"style_image__2TW85"};